module.exports = __webpack_public_path__ + "static/media/partner-logo11.f7d15f1e.png";